import { useState } from "react";
import toast from "react-hot-toast";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomSelect from "../../../common/CustomSelect";
import CustomButton from "../../../common/CustomButton";
import CustomActionButton from "../../../common/CustomActionButton";
import CustomModal from "../../../common/CustomModal";


import { delay, allFieldsHaveValue } from "../../../utils";

function PromptPropsDetails(props) {

    const [propsDetails, setPropsDetails] = useState(!props?.initialData ? {
        name: "",
        key: "",
        note: "",
        type: "text",
    } : { ...props?.initialData });

    const [selectOptions, setSelectOptions] = useState(props?.initialData?.options?.length > 0 ? props?.initialData?.options : [
        { label: "", value: "" },
    ]);

    const types = [
        { label: "Text", value: "text" },
        { label: "Date", value: "date" },
        { label: "Select", value: "select" },
        { label: "Week", value: "week" },
        { label: "Program", value: "program" },
    ];

    const handleChange = (e) => {
        setPropsDetails({
            ...propsDetails,
            [e.target.name]: e.target.value,
        });
    }

    const addOption = () => {
        setSelectOptions([...selectOptions, { label: "", value: "" }]);
    }

    const removeOption = (index) => {
        setSelectOptions(selectOptions.filter((opt, i) => i !== index));
    }

    const handleOptionsChange = (e, index) => {
        const newOptions = selectOptions.map((opt, i) => {
            if (i === index) {
                return {
                    ...opt,
                    [e.target.name]: e.target.value,
                }
            }

            return opt;
        });

        setSelectOptions(newOptions);

    }
    const isActive = !allFieldsHaveValue(propsDetails?.type == "select" ? { ...propsDetails, options: selectOptions } : { ...propsDetails }, ["note", "index", "value"]);

    return (
        <div id="pd-add-props-modal" >
            <div className="row">
                <div className="col-12 mb-4">
                    <h5>Name</h5>
                    <CustomInputV2
                        required={true}
                        value={propsDetails?.name}
                        type="text"
                        onChange={handleChange}
                        name="name"
                    />
                </div>

                <div className="col-12 mb-4">
                    <h5>Key</h5>
                    <CustomInputV2
                        required={true}
                        value={propsDetails?.key}
                        type="text"
                        onChange={handleChange}
                        name="key"
                    />
                </div>

                <div className="col-12 mb-4">
                    <h5>Type</h5>
                    <div className={propsDetails?.type === "select" && "pd-a-p-select"}>
                        <div>
                            <CustomSelect
                                name="type"
                                options={types}
                                value={propsDetails?.type}
                                onChange={handleChange}
                            />
                        </div>

                        {
                            propsDetails?.type === "select" &&
                            <div>
                                <AddIcon onClick={addOption} />
                            </div>
                        }

                    </div>

                    {
                        propsDetails?.type === "select" &&
                        <div className="pd-add-select-options">
                            {
                                selectOptions?.map((opt, index) => {
                                    return (
                                        <div className="row">
                                            {selectOptions?.length > 1 && <DeleteIcon className="pd-delete-option" onClick={() => {
                                                removeOption(index);
                                            }} />}
                                            <div className="col-md-6">
                                                <h6>Label:</h6>
                                                <CustomInputV2
                                                    required={true}
                                                    value={opt?.label}
                                                    type="text"
                                                    onChange={(e) => {
                                                        handleOptionsChange(e, index);
                                                    }}
                                                    name="label"
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <h6>Value:</h6>
                                                <CustomInputV2
                                                    required={true}
                                                    value={opt?.value}
                                                    type="text"
                                                    onChange={(e) => {
                                                        handleOptionsChange(e, index);
                                                    }}
                                                    name="value"
                                                />
                                            </div>
                                        </div>
                                    )
                                })
                            }

                        </div>
                    }
                </div>

                <div className="col-12 mb-4">
                    <h5>Notes</h5>
                    <CustomInputV2
                        placeholder="sample value"
                        value={propsDetails?.note}
                        type="text"
                        onChange={handleChange}
                        name="note"
                    />
                </div>
            </div>

            <div id="pd-add-props-actions">
                {
                    !props?.initialData &&
                    <CustomActionButton
                        disabled={isActive}
                        action={async () => {
                            const res = await props?.addProps({ ...propsDetails, options: selectOptions });

                            props?.exit();

                            return res;
                        }}
                    >
                        Add
                    </CustomActionButton>

                }


                {
                    props?.initialData &&
                    <CustomActionButton
                        disabled={isActive}
                        action={async () => {
                            const res = await props?.updateProps({ ...propsDetails, options: selectOptions, index: props?.initialData?.index });

                            props?.exit();

                            return res;
                        }}
                    >
                        Update
                    </CustomActionButton>
                }


            </div>

        </div>
    );
}

export default PromptPropsDetails;